import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const PICKUP_API = `${BACKEND_URL}/api/pickup`;

const TOKEN_KEY = "madaris_guardian_token";

export const getGuardianToken = () => localStorage.getItem(TOKEN_KEY);
export const setGuardianToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearGuardianToken = () => localStorage.removeItem(TOKEN_KEY);

export const guardianApi = axios.create({ baseURL: PICKUP_API });

guardianApi.interceptors.request.use((config) => {
  const t = getGuardianToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

guardianApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) clearGuardianToken();
    return Promise.reject(err);
  }
);

export const guardianRegister = (data) => guardianApi.post("/auth/register", data).then(r => r.data);
export const guardianLogin = (data) => guardianApi.post("/auth/login", data).then(r => r.data);
export const guardianMe = () => guardianApi.get("/auth/me").then(r => r.data);
export const myChildren = () => guardianApi.get("/my-children").then(r => r.data);
export const searchStudentByNationalId = (national_id) => guardianApi.get("/students/search", { params: { national_id } }).then(r => r.data);
export const linkStudent = (student_id) => guardianApi.post("/students/link", { student_id }).then(r => r.data);
export const createPickupRequest = (student_id) => guardianApi.post("/requests", { student_id }).then(r => r.data);
export const cancelPickupRequest = (rid) => guardianApi.post(`/requests/${rid}/cancel`).then(r => r.data);
export const getPickupSettings = () => guardianApi.get("/settings").then(r => r.data);
